// src/components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


const isTokenValid = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() < exp * 1000;
  } catch {
    return false;
  }
};

const PrivateRouter = ({ children }) => {
  const token = localStorage.getItem("token");

  return token && isTokenValid(token) ? children : <Navigate to="/login" />;
};

export default PrivateRouter;
